import { useState } from 'react';
import { Checkbox } from "../../../checkbox/Checkbox.js";
import { InfoTag } from "../../../infoTag/InfoTag.js";
import { InputSearch } from "../../../inputSearch/InputSearch.js";
import { Separator } from "../../../separator/Separator.js";
import { Typography } from "../../../typography/Typography.js";
import { MultiSelectSearchItem } from "../MultiSelectSearchItem/MultiSelectSearchItem.js";
import styles from "./MultiSelectSearchList.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MultiSelectSearchList({
  title,
  searchLabel,
  onSearchChange,
  items,
  onSelectionChange
}) {
  const [searchQuery, setSearchQuery] = useState('');
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.title,
        children: [/*#__PURE__*/_jsx(Typography, {
          margin: false,
          variant: "h4",
          children: title
        }), /*#__PURE__*/_jsx(InfoTag, {
          label: items.length.toString()
        })]
      }), /*#__PURE__*/_jsx(Checkbox, {
        checked: !items.some(item => !item.checked),
        isIntermediate: items.some(item => item.checked) && items.some(item => !item.checked),
        onChange: e => {
          onSelectionChange(items.map(item => {
            return {
              ...item,
              checked: e.target.checked
            };
          }), items.filter(item => e.target.checked ? !item.checked : item.checked).map(item => item.id));
        },
        children: "Alle ausw\xE4hlen"
      })]
    }), /*#__PURE__*/_jsx(Separator, {}), /*#__PURE__*/_jsx("div", {
      className: styles.search,
      children: /*#__PURE__*/_jsx(InputSearch, {
        placeholder: searchLabel ?? 'Suchen',
        small: true,
        value: searchQuery,
        onChange: e => {
          setSearchQuery(e.target.value);
          onSearchChange(e.target.value);
        }
      })
    }), items.length > 0 && /*#__PURE__*/_jsx("div", {
      className: styles.list,
      children: items.filter(item => item.includedInSearch).map(item => /*#__PURE__*/_jsx(MultiSelectSearchItem, {
        item: item,
        onSelect: (itemId, checked) => {
          onSelectionChange(items.map(item => item.id === itemId ? {
            ...item,
            checked
          } : item), [itemId]);
        }
      }, item.id))
    })]
  });
}